import { render } from "./CommandBar.vue?vue&type=template&id=610734be&scoped=true"
import script from "./CommandBar.vue?vue&type=script&lang=js"
export * from "./CommandBar.vue?vue&type=script&lang=js"

import "./CommandBar.vue?vue&type=style&index=0&id=610734be&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-610734be"]])

export default __exports__